import React, { useState } from "react";
import SidebarTrainer from "../components/trainer/SidebarTrainer";
import TrainerCalendar from "../components/trainer/TrainerCalendar";
const TrainerPanel = () => {
  const [activeComponent, setActiveComponent] = useState("Dashboard");

  // Function to render the selected component
  const renderComponent = () => {
    switch (activeComponent) {
      case "Kalendarz":
        return <TrainerCalendar />;
      default:
        return <TrainerCalendar />;
    }
  };

  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <SidebarTrainer setActiveComponent={setActiveComponent} />

      {/* Main content area */}
      <div className="flex-1 p-5 bg-gray-100">{renderComponent()}</div>
    </div>
  );
};

export default TrainerPanel;
